export default __webpack_public_path__ + "56b4cff77fb508cd3286a6984a380825.png";